import { render, staticRenderFns } from "./CattleSmallNew.vue?vue&type=template&id=1451c514&scoped=true"
import script from "./CattleSmallNew.vue?vue&type=script&lang=js"
export * from "./CattleSmallNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451c514",
  null
  
)

export default component.exports